// removed by extract-text-webpack-plugin
module.exports = {"profileContainer":"_75F1Z"};


//////////////////
// WEBPACK FOOTER
// ./app/components/profile-page-layout/profile-page-layout.scss
// module id = 1771
// module chunks = 0